
import React from 'react';
import { Eye, Heart, Star } from 'lucide-react';
import { useProductStats } from '@/hooks/useProductStats';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface ProductStatsProps {
  productId: string;
  sellerId?: string;
  className?: string;
}

export const ProductStats: React.FC<ProductStatsProps> = ({ productId, sellerId, className }) => {
  const { viewCount, favoriteCount, isLoading } = useProductStats(productId);
  
  // Get seller average rating if seller ID is provided
  const { data: sellerRating = 0 } = useQuery({
    queryKey: ['sellerRating', sellerId],
    queryFn: async () => {
      if (!sellerId) return 0;
      
      const { data, error } = await supabase
        .rpc('get_user_average_rating', {
          user_id: sellerId
        } as any);
        
      if (error) {
        return 0;
      }
      
      return Number(data) || 0;
    },
    enabled: !!sellerId,
  });
  
  if (isLoading) {
    return (
      <div className={`flex items-center space-x-4 text-sm text-gray-500 ${className || ''}`}>
        <div className="h-4 w-16 bg-gray-200 animate-pulse rounded"></div>
        <div className="h-4 w-16 bg-gray-200 animate-pulse rounded"></div>
      </div>
    );
  }
  
  return (
    <div className={`flex items-center space-x-4 text-sm text-gray-500 ${className || ''}`}>
      <div className="flex items-center">
        <Eye className="h-4 w-4 mr-1 text-gray-400" />
        <span>{viewCount} shikime</span>
      </div>
      <div className="flex items-center">
        <Heart className="h-4 w-4 mr-1 text-gray-400" />
        <span>{favoriteCount} të preferuara</span>
      </div>
      {sellerId && (
        <div className="flex items-center">
          <Star className="h-4 w-4 mr-1 text-amber-400" />
          <span>{sellerRating.toFixed(1)} vlerësime</span>
        </div>
      )}
    </div>
  );
};
